<template>
  <div class="check_box center">
    <a-radio-group
      v-model="isshow"
      style="margin-top:20px;"
      @change="onChangeSex"
    >
      <a-radio-button :value="1">按人体</a-radio-button>
      <a-radio-button :value="2">按部位</a-radio-button>
    </a-radio-group>

    <div
      class="hp_space_between"
      @click="cell = false"
      v-if="isshow===1"
    >
      <div
        class="top"
        v-show="true"
      >
        <div class="img-wrap">
          <img
            :src="imgSrc"
            alt
          />
        </div>

        <div
          class="pos"
          v-show="personType == 1"
        >
          <div
            v-show="direction == 1"
            class="tou"
            @click.stop="openMenu($event, 1)"
          ></div>
          <div
            v-show="direction == 1"
            class="jin"
            @click.stop="openMenu($event, 2)"
          ></div>
          <div
            v-show="direction == 1"
            class="shou l"
            @click.stop="openMenu($event, 3)"
          ></div>
          <div
            v-show="direction == 1"
            class="shou r"
            @click.stop="openMenu($event, 3)"
          ></div>
          <div
            v-show="direction == 1"
            class="xiong"
            @click.stop="openMenu($event, 4)"
          ></div>
          <div
            v-show="direction == 1"
            class="fu"
            @click.stop="openMenu($event, 5)"
          ></div>
          <div
            v-show="direction == 1"
            class="kuan"
            @click.stop="openMenu($event, 6)"
          ></div>
          <div
            v-show="direction == 1"
            class="xiazhi l"
            @click.stop="openMenu($event, 7)"
          ></div>
          <div
            v-show="direction == 1"
            class="xiazhi r"
            @click.stop="openMenu($event, 7)"
          ></div>
          <div
            v-show="direction == 2"
            class="beibu"
            @click.stop="openMenu($event, 8)"
          ></div>
          <div
            v-show="direction == 2"
            class="yaobu"
            @click.stop="openMenu($event, 9)"
          ></div>
          <div
            v-show="direction == 2"
            class="tunbu"
            @click.stop="openMenu($event, 10)"
          ></div>
        </div>
        <div
          class="pos"
          v-show="personType == 2"
        >
          <div
            v-show="direction == 1"
            class="tou"
            @click.stop="openMenu($event, 1)"
          ></div>
          <div
            v-show="direction == 1"
            class="jin"
            @click.stop="openMenu($event, 2)"
          ></div>
          <div
            v-show="direction == 1"
            class="shou l"
            @click.stop="openMenu($event, 3)"
          ></div>
          <div
            v-show="direction == 1"
            class="shou r"
            @click.stop="openMenu($event, 3)"
          ></div>
          <div
            v-show="direction == 1"
            class="xiong"
            @click.stop="openMenu($event, 4)"
          ></div>
          <div
            v-show="direction == 1"
            class="fu"
            @click.stop="openMenu($event, 5)"
          ></div>
          <div
            v-show="direction == 1"
            class="kuan"
            @click.stop="openMenu($event, 6)"
          ></div>
          <div
            v-show="direction == 1"
            class="xiazhi l"
            @click.stop="openMenu($event, 7)"
          ></div>
          <div
            v-show="direction == 1"
            class="xiazhi r"
            @click.stop="openMenu($event, 7)"
          ></div>
          <div
            v-show="direction == 2"
            class="beibu"
            @click.stop="openMenu($event, 8)"
          ></div>
          <div
            v-show="direction == 2"
            class="yaobu"
            @click.stop="openMenu($event, 9)"
          ></div>
          <div
            v-show="direction == 2"
            class="tunbu"
            @click.stop="openMenu($event, 10)"
          ></div>
        </div>
        <div
          class="pos er"
          v-show="personType == 3"
        >
          <div
            v-show="direction == 1"
            class="tou"
            @click.stop="openMenu($event, 1)"
          ></div>
          <div
            v-show="direction == 1"
            class="jin"
            @click.stop="openMenu($event, 2)"
          ></div>
          <div
            v-show="direction == 1"
            class="shou l"
            @click.stop="openMenu($event, 3)"
          ></div>
          <div
            v-show="direction == 1"
            class="shou r"
            @click.stop="openMenu($event, 3)"
          ></div>
          <div
            v-show="direction == 1"
            class="xiong"
            @click.stop="openMenu($event, 4)"
          ></div>
          <div
            v-show="direction == 1"
            class="fu"
            @click.stop="openMenu($event, 5)"
          ></div>
          <div
            v-show="direction == 1"
            class="kuan"
            @click.stop="openMenu($event, 6)"
          ></div>
          <div
            v-show="direction == 1"
            class="xiazhi l"
            @click.stop="openMenu($event, 7)"
          ></div>
          <div
            v-show="direction == 1"
            class="xiazhi r"
            @click.stop="openMenu($event, 7)"
          ></div>
          <div
            v-show="direction == 2"
            class="beibu"
            @click.stop="openMenu($event, 8)"
          ></div>
          <div
            v-show="direction == 2"
            class="yaobu"
            @click.stop="openMenu($event, 9)"
          ></div>
          <div
            v-show="direction == 2"
            class="tunbu"
            @click.stop="openMenu($event, 10)"
          ></div>
        </div>
      </div>
      <div class="right">
        <div class="sex_box">
          <span>背面</span>
          <a-switch
            default-checked
            @change="onChangeFront"
          />
          <span>正面</span>
        </div>

        <a-radio-group
          v-model="personType"
          style="margin-top:20px;"
          @change="onChangeSex"
        >
          <a-radio-button
            v-for="(i,index) in sexList"
            :key="index"
            :value="i.id"
          >{{i.text}}</a-radio-button>
        </a-radio-group>
      </div>

      <div
        class="list_box"
        :style="`top:${top}px;left:${left}px;`"
        v-show="cell"
        @click.stop
      >
        <div class="box">
          <div
            class="list"
            v-for="(i,index) in menusList"
            :key="index"
            @click="cellClick(i,0)"
          >
            <p>{{i.name}}</p>
            <a-icon type="right" />
          </div>
        </div>
        <div
          class="box"
          v-if="zkList.length>0"
        >
          <div
            class="list"
            v-for="(i,index) in zkList"
            :key="index"
            @click="cellClick(i,1)"
          >
            <p>{{i.name}}</p>
            <a-icon type="right" />
          </div>
        </div>
        <div
          class="box"
          v-if="xqList.length>0"
        >
          <div
            class="list"
            v-for="(i,index) in xqList"
            :key="index"
            @click="cellClick(i,2)"
          >
            <p>{{i.name}}</p>
            <a-icon type="right" />
          </div>
        </div>
        <div
          class="box"
          v-show="tjkeList.length>0"
        >
          <div
            class="list"
            v-for="(i,index) in tjkeList"
            :key="index"
            @click="toPage(i.id)"
          >
            <p>{{i.hospitalName}}>{{i.name}}</p>
            <a-icon type="right" />
          </div>
        </div>
      </div>
    </div>

    <!-- 按部位 -->
    <div
      class="hp_space_between"
      v-else
    >
      <div class="radio">
        <!-- <a-cascader :options="options" placeholder="Please select" @change="onChange" /> -->
        <div class="cell_box">
          <div
            class="list"
            v-for="(i,index) in newsList"
            :key="index"
            @click="cellClick(i,0)"
          >
            <p>{{i.name}}</p>
            <a-icon type="right" />
          </div>
        </div>

        <div
          class="cell_box"
          v-show="zkList.length>0"
        >
          <div
            class="list"
            v-for="(i,index) in zkList"
            :key="index"
            @click="cellClick(i,1)"
          >
            <p>{{i.name}}</p>
            <a-icon type="right" />
          </div>
        </div>

        <div
          class="cell_box"
          v-show="xqList.length>0"
        >
          <div
            class="list"
            v-for="(i,index) in xqList"
            :key="index"
            @click="cellClick(i,2)"
          >
            <p>{{i.name}}</p>
            <a-icon type="right" />
          </div>
        </div>

        <div
          class="cell_box"
          v-show="tjkeList.length>0"
        >
          <div
            class="list"
            v-for="(i,index) in tjkeList"
            :key="index"
            @click="toPage(i.id)"
          >
            <p>{{i.hospitalName}}>{{i.name}}</p>
            <a-icon type="right" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getBodyInfo,
  byPartId,
  getSympById,
  getDeptBySympId,
} from "@/api/index";
import { ls } from "@/utils/tool";
export default {
  data() {
    return {
      isshow: 1,
      personType: 1,
      direction: 1,
      febe: false,
      act: 0,
      front: true,
      imgSrc: "https://app-img.zuoshouyisheng.com/huatuo/man_z.png",
      size: "default",
      left: 0,
      top: 0,
      cell: false,
      menusList: [],
      sexList: [
        {
          text: "男",
          id: 1,
        },
        {
          text: "女",
          id: 2,
        },
        {
          text: "童",
          id: 3,
        },
      ],
      newsList: [],
      zkList: [],
      xqList: [],
      tjkeList: [],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    async getList(opt) {
      var data = {
        direction: this.direction,
        personType: this.personType,
        ...opt,
      };
      var rs = await getBodyInfo(data);
      console.log("rs -> :", rs);
      this.newsList = rs.data;
    },
    toPage(id) {
      this.$router.push("/registered/dept/" + id);
    },
    async openMenu(e, pid) {
      if (!ls.get("token")) {
        this.$message.warning("请先前往登录!");
        return;
      }
      this.left = e.pageX;
      this.top = e.pageY;
      var rs = await getBodyInfo({
        pid,
      });
      this.menusList = rs.data;
      this.cell = true;
      this.clearList();
    },
    onChangeFront(checked) {
      this.front = checked;
      this.direction = checked ? 1 : 2;
      this.setImgSrc();
    },
    onChangeSex(e) {
      this.personType === e.target.value;
      this.setImgSrc();
    },
    setImgSrc() {
      if (this.personType === 1 && this.front) {
        this.imgSrc = "https://app-img.zuoshouyisheng.com/huatuo/man_z.png";
      }
      if (this.personType === 1 && !this.front) {
        this.imgSrc = "https://app-img.zuoshouyisheng.com/huatuo/man_b.png";
      }
      if (this.personType === 2 && this.front) {
        this.imgSrc = "https://app-img.zuoshouyisheng.com/huatuo/woman_z.png";
      }
      if (this.personType === 2 && !this.front) {
        this.imgSrc = "https://app-img.zuoshouyisheng.com/huatuo/woman_b.png";
      }
      if (this.personType === 3 && this.front) {
        this.imgSrc = "https://app-img.zuoshouyisheng.com/huatuo/kid_z.png";
      }
      if (this.personType === 3 && !this.front) {
        this.imgSrc = "https://app-img.zuoshouyisheng.com/huatuo/kid_b.png";
      }
    },
    clearList(num) {
      switch (num) {
        case 0:
          this.xqList = [];
          this.tjkeList = [];
          break;
        case 1:
          this.tjkeList = [];
          break;
        case 2:
          break;
        default:
          this.zkList = [];
          this.xqList = [];
          this.tjkeList = [];
      }
    },
    async cellClick(item, num) {
      let data;
      let res;
      if (num === 0) {
        data = {
          personType: this.personType,
          partId: item.id,
        };
        res = await byPartId(data);
        if (res.code == 200) {
          this.zkList = res.data;
        }
        // window.scrollTo(0,0)
      } else if (num === 1) {
        data = {
          personType: this.personType,
          id: item.id,
        };
        res = await getSympById(data);
        if (res.code == 200) {
          this.xqList = res.data;
        }
      } else if (num === 2) {
        data = {
          id: item.id,
        };
        res = await getDeptBySympId(data);
        if (res.code == 200) {
          if (res.data.length <= 0) {
            this.$message.warning("该症状暂无推荐科室");
          }
          this.tjkeList = res.data;
        }
      }
      this.clearList(num);
    },
  },
};
</script>
<style lang='less'>
.center {
  width: 1200px;
  margin: auto;
  .top {
    position: relative;

    .img-wrap {
      height: calc(100vh - 46px);
      position: relative;

      img {
        height: 100%;
      }
    }
    .pos {
      height: calc(100vh - 46px);
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;

      div {
        position: absolute;
      }

      .tou {
        left: 50%;
        top: 6%;
        -webkit-transform: translateX(-50%);
        transform: translateX(-50%);
        width: 13%;
        height: 68px;
      }

      .jin {
        left: 50%;
        top: 16%;
        -webkit-transform: translateX(-50%);
        transform: translateX(-50%);
        width: 10%;
        height: 38px;
      }

      .shou {
        top: 22%;
        height: 250px;
      }

      .shou.l {
        left: 32%;
        -webkit-transform: translateX(-32%);
        transform: translateX(-32%);
        width: 8%;
      }

      .shou.r {
        left: 69%;
        -webkit-transform: translateX(-69%);
        transform: translateX(-69%);
        width: 8%;
      }

      .xiong {
        left: 50%;
        -webkit-transform: translateX(-50%);
        transform: translateX(-50%);
        top: 22%;
        width: 24%;
        height: 78px;
      }

      .beibu {
        left: 50%;
        -webkit-transform: translateX(-50%);
        transform: translateX(-50%);
        top: 22%;
        width: 24%;
        height: 104px;
      }

      .yaobu {
        left: 50%;
        -webkit-transform: translateX(-50%);
        transform: translateX(-50%);
        top: 37%;
        width: 20%;
        height: 60px;
      }

      .tunbu {
        left: 50%;
        -webkit-transform: translateX(-50%);
        transform: translateX(-50%);
        top: 46%;
        width: 22%;
        height: 50px;
      }

      .fu {
        left: 50%;
        -webkit-transform: translateX(-50%);
        transform: translateX(-50%);
        top: 34%;
        width: 20%;
        height: 82px;
      }

      .kuan {
        left: 50%;
        -webkit-transform: translateX(-50%);
        transform: translateX(-50%);
        top: 46%;
        width: 24%;
        height: 54px;
      }

      .xiazhi {
        left: 50%;
        -webkit-transform: translateX(-50%);
        transform: translateX(-50%);
        top: 54%;
        height: 280px;
      }

      .xiazhi.l {
        -webkit-transform: translateX(-42%);
        transform: translateX(-42%);
        left: 42%;
        width: 12%;
      }

      .xiazhi.r {
        -webkit-transform: translateX(-58%);
        transform: translateX(-58%);
        left: 58%;
        width: 12%;
      }
    }

    .er {
      .tou {
        left: 53%;
        -webkit-transform: translateX(-53%);
        transform: translateX(-53%);
        top: 22%;
        width: 38%;
        height: 168px;
      }

      .jin {
        left: 52%;
        -webkit-transform: translateX(-52%);
        transform: translateX(-52%);
        top: 46%;
        width: 14%;
        height: 45px;
      }

      .shou {
        top: 50%;
        height: 70px;
      }

      .shou.l {
        left: 32%;
        -webkit-transform: translateX(-32%);
        transform: translateX(-32%);
        width: 12%;
      }

      .shou.r {
        left: 70%;
        -webkit-transform: translateX(-69%);
        transform: translateX(-69%);
        width: 9%;
        height: 130px;
      }

      .xiong {
        left: 52%;
        -webkit-transform: translateX(-52%);
        transform: translateX(-52%);
        top: 53%;
        width: 17%;
        height: 28px;
      }

      .beibu {
        left: 53%;
        -webkit-transform: translateX(-53%);
        transform: translateX(-53%);
        top: 50%;
        width: 20%;
        height: 60px;
      }

      .yaobu {
        left: 53%;
        -webkit-transform: translateX(-53%);
        transform: translateX(-53%);
        top: 60%;
        width: 22%;
        height: 14px;
      }

      .tunbu {
        left: 53%;
        -webkit-transform: translateX(-53%);
        transform: translateX(-53%);
        top: 63%;
        width: 22%;
        height: 50px;
      }

      .fu {
        left: 52%;
        -webkit-transform: translateX(-52%);
        transform: translateX(-52%);
        top: 58%;
        width: 20%;
        height: 24px;
      }

      .kuan {
        left: 52%;
        -webkit-transform: translateX(-52%);
        transform: translateX(-52%);
        top: 62%;
        width: 24%;
        height: 54px;
      }

      .xiazhi {
        top: 70%;
        height: 80px;
      }

      .xiazhi.l {
        -webkit-transform: translateX(-46%);
        transform: translateX(-46%);
        left: 46%;
        width: 8%;
      }

      .xiazhi.r {
        -webkit-transform: translateX(-58%);
        transform: translateX(-58%);
        left: 58%;
        width: 8%;
      }
    }
  }
  .right {
    flex: 1;
    .sex_box {
      padding-top: 30px;
      display: flex;
      align-items: center;
      span {
        display: inline-block;
        font-size: 15px;
        padding: 0 10px;
      }
    }
  }
  .list_box {
    user-select: none;
    position: absolute;
    display: flex;
    z-index: 100;
    max-height: 600px;
    .box {
      min-width: 100px;
      //   margin-right: 5px;
      //   border: 1px solid #ccc;
      overflow: auto;
      .list {
        background: #fff;
        display: flex;
        align-items: center;
        padding: 10px;
        cursor: pointer;
        &:hover {
          background: #f2f2f2;
        }
        p {
          margin: 0;
          margin-right: 10px;
          font-size: 15px;
          flex: 1;
        }
      }
    }
  }

  .radio {
    display: flex;
    .cell_box {
      margin-top: 10px;
      //   width: 200px;
      border: 1px solid #f2f2f2;
      margin-right: 5px;
      //   display: flex;
      //   align-items: center;
      .list {
        display: flex;
        align-items: center;
        padding: 20px;
        cursor: pointer;
        &:hover {
          background: #f2f2f2;
        }
        p {
          margin: 0;
          font-size: 15px;
          flex: 1;
          margin-right: 10px;
        }
      }
    }
  }
}
</style>
